export const navigation = {
    state: { menuOpen: false, sideNavOpen: false, showSideNavButton: false },
    reducers: {
        toggleMenu: (state, menuState) => ({ ...state, menuOpen: menuState !== undefined ? menuState : !state.menuOpen }),
        toggleSideNav: state => ({ ...state, sideNavOpen: !state.sideNavOpen }),
        showSideNavButton: state => ({ ...state, showSideNavButton: true }),
        hideSideNavButton: state => ({ ...state, showSideNavButton: false })
    }
};
